import React, {useState, useEffect} from "react";
import { Link as RouterLink, withRouter } from 'react-router-dom';
import { makeStyles } from "@material-ui/styles";
import PropTypes from 'prop-types';
import DeviceUpdateForm from "./DeviceUpdateForm";
import { SIREN_CONFIG } from 'config.js';
import {useSelector} from 'react-redux';


const DeviceUpdate = (props) => {

  const {className, match, history, ...rest } = props;
  const classes = useStyles();

  const [deviceInfo, setDeviceInfo] = useState(null);
  const facility_id = useSelector((store) => store.user.facility_id);

  const loadData = (deviceId) => {

    var url = `${SIREN_CONFIG.HOSTNAME}/device/deviceInfo?facility_id=${facility_id}&deviceId=${deviceId}`;

    fetch(url)
    .then(res => res.json())
    .then(snapshot => {

      var deviceInfo = {
        deviceId: snapshot.resultData[0].deviceId,
        installed_roomId: snapshot.resultData[0].installed_roomId,
        installed_pos_detail: snapshot.resultData[0].installed_pos_detail,
        keepOnFall: snapshot.resultData[0].keepOnFall,
        roomType: snapshot.resultData[0].roomType,
        patientId: snapshot.resultData[0].patientId,
        roomName: snapshot.resultData[0].roomName,
        silent_mode: snapshot.resultData[0].silentMode,
        wakeUpDetect: snapshot.resultData[0].wakeUpDetect,
        sleepAnalysis: snapshot.resultData[0].sleepAnalysis,
        isActive: snapshot.resultData[0].isActive,
        memo: snapshot.resultData[0].memo,
        snapshotPresence: snapshot.resultData[0].snapshotPresence,
        bucketName: snapshot.resultData[0].bucketName,
        streamName: snapshot.resultData[0].streamName,
      };

      setDeviceInfo(deviceInfo);
    });
  }


  useEffect( () => {
    loadData(match.params.deviceId);
  }, []);


  return (
    <div className={classes.root}>
      <div className={classes.content}>
        { deviceInfo && <DeviceUpdateForm deviceInfo={deviceInfo} history={history} /> }
      </div>
    </div>
  );
};


DeviceUpdate.propTypes = {
  history: PropTypes.object
};

export default withRouter(DeviceUpdate);

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  content: {
    marginTop: theme.spacing(2),
  },
}));

